import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isAuthenticated: false,
  userId: "",
  firstName: "",
  lastName: "",
  avatar: "",
  role: "",
  wallet: 0,
  propertyId: "",
  Email: "",
  Mobilenumber: "",
  isSubscribed:false,
  isKyc:false,
  user_refferal_code:""
};
const useSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginUser(state, action) {
      state.isAuthenticated = true;
      state.userId = action.payload.user.id;
      state.firstName = action.payload.user.firstName;
      state.lastName = action.payload.user.lastName;
      state.avatar = action.payload.user.avatar;
      state.role = action.payload.user.role;
      state.wallet = action.payload.user.wallet;
      state.Email = action.payload.user.Email;
      state.Mobilenumber = action.payload.user.Mobilenumber;
      state.isSubscribed = action.payload.user.isSubscribed;
      state.isKyc=action.payload.user.isKyc;
      state.user_refferal_code=action.payload.user.refferal_code;
      state.isVerified=action.payload.user.isVerified;
     
    },
    logoutUser(state) {
      state.isAuthenticated = false;
      state.userId = "";
      state.firstName = "";
      state.lastName = "";
      state.avatar = "";
      state.role = "";
      state.wallet = 0;
      state.Email = "";
      state.Mobilenumber = "";
      state.isSubscribed=false;
      state.isKyc=false;
      state.user_refferal_code="";
      state.isVerified=false;
    },
    updateWallet(state, action) {
      // New reducer to update the wallet balance
      state.wallet = action.payload.wallet;
    },
    updatePropertyId(state, action) {
      state.propertyId = action.payload.propertyId; // Allow dynamic propertyId updates
    },
    updateSubscription(state, action) {
     
      state.isSubscribed = action.payload.isSubscribed;
     
    },
    kycStatus(state,action){
     
      state.isKyc=action.payload.isKyc;
     
    },
  },
});
export const { loginUser, logoutUser, updateWallet, updatePropertyId,updateSubscription,kycStatus,updateProfile } =
  useSlice.actions;
export default useSlice.reducer;